<template>
  <div class="common-panel">
    <div class="top-left-medium"></div>
    <div class="bottom-left-medium"></div>
    <div class="top-right-medium"></div>
    <div class="bottom-right-medium"></div>
    <div class="top-left-small"></div>
    <div class="bottom-left-small"></div>
    <div class="top-right-small"></div>
    <div class="bottom-right-small"></div>
    <div class="slot-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonPanel',
  componentName: 'CommonPanel',
};
</script>

<style lang="scss" scoped>
  $full-border-color: #0096EA;
  $medium-border-color: #0096EA;
  $small-border-color: #00A3FF;

  .common-panel {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 80px;
    min-height: 80px;
    border:2px solid rgba($full-border-color, 0.4);
    border-radius: 5px;
    box-sizing: border-box;
    > div {
      position: absolute;
    }
    > div.slot-content {
      position: relative;
      width: 100%;
      height: 98%;
      box-sizing: border-box;
      padding: 10px 10px;
    }
    @each $tb in top, bottom {
      @each $lr in left, right {
        & .#{$tb}-#{$lr}-medium {
          width: 30px;
          height: 30px;
          border-#{$tb}-#{$lr}-radius: 5px;
          border-#{$tb}: 2px solid rgba($medium-border-color, 0.6);
          border-#{$lr}: 2px solid rgba($medium-border-color, 0.6);
          #{$tb}: -2px;
          #{$lr}: -2px;
        }
        & .#{$tb}-#{$lr}-small {
          width: 15px;
          height: 15px;
          border-#{$tb}-#{$lr}-radius: 5px;
          border-#{$tb}: 3px solid rgba($small-border-color, 1);
          border-#{$lr}: 3px solid rgba($small-border-color, 1);
          #{$tb}: -2px;
          #{$lr}: -2px;
        }
      }
    }
  }

</style>
